import { RowGridProps, RowGrid } from 'framework/list';
import React from 'react';

const LeavesRowGrid = ({ containerSx, ...props }: RowGridProps) => {
  const customContainerSx = {
    border: 'none',
    borderRadius: 0,
    borderBottom: '1px solid var(--mui-palette-TableCell-border)',
    backgroundColor: 'transparent',
  };

  return (
    <RowGrid
      {...props}
      expandIconInFirstCell
      useCollapseForExpandable
      containerSx={{
        ...customContainerSx,
        ...containerSx,
      }}
    />
  );
};

export default LeavesRowGrid;
